import React from 'react';
import './Overlays.css';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';
type EpassRequiredOverlayProps = {
  handleRequired: () => void;
  redirectToCabsPage: (cabsListingUrl?: string) => void;
  carPrice: string;
};
const EpassRequiredOverlay = ({
  handleRequired,
  redirectToCabsPage,
  carPrice
}: EpassRequiredOverlayProps) => {
  const onBookNowClcik = () => {
    trackEPassPageEvent('Cab_SEO_Epass_Popup_Booknow_Click');
    redirectToCabsPage();
  };
  return (
    <div className="epass__overlay makeFlex column">
      <span className="epass__overlay__close" onClick={handleRequired}></span>
      <p className="epass__form__title latoBlack dark__text">
        {`e-Pass is required on your route`}
      </p>
      <p className="epass__form__subtitle">
        {`Follow these simple steps to book a cab along with an e-Pass:`}
      </p>
      <ul className="epass__req__list">
        <li>
          <p className="latoBold blackText title__text">
            {`Book your cab starting @ ₹${carPrice}`}
          </p>
          <p className="greyText desc__text">
            {`Receive cab/driver details post booking`}
          </p>
        </li>
        <li>
          <p className="latoBold blackText title__text">
            {`Provide your cab details`}
          </p>
          <p className="greyText desc__text">
            {`Use the received details to apply for an e-Pass on the state govt.
            site`}
          </p>
        </li>
        <li>
          <p className="latoBold blackText title__text">{`Upload your e-Pass`}</p>
          <p className="greyText desc__text">
            {`On the link shared post booking, to avoid cancellation.`}
          </p>
        </li>
      </ul>
      <button className="epass__form__btn" onClick={onBookNowClcik}>
        {' '}
        Book Now
      </button>
    </div>
  );
};
export default EpassRequiredOverlay;
